// extracted by mini-css-extract-plugin
var _1 = "assets-js-ViewInvitation-components-Guestlist-Post-ReplyForm-module__comment__s2WXc";
var _2 = "assets-js-ViewInvitation-components-Guestlist-Post-ReplyForm-module__form__iqCNx";
var _3 = "assets-js-ViewInvitation-components-Guestlist-Post-ReplyForm-module__formAbsolute__dZNJN";
var _4 = "assets-js-ViewInvitation-components-Guestlist-Post-ReplyForm-module__formAbsoluteHeader__spitK";
var _5 = "assets-js-ViewInvitation-components-Guestlist-Post-ReplyForm-module__submitButton__HumoZ";
export { _1 as "comment", _2 as "form", _3 as "formAbsolute", _4 as "formAbsoluteHeader", _5 as "submitButton" }
